// rsuite
import { ButtonToolbar } from 'rsuite';
// components
import { ExButton } from '@commons/EXComponentsLibrary';
// utils && hooks
import { handlerDownloadErrors } from './handler';
// style
import style from './DragDropWithErrors.module.css';

const _MESSAGES = {
    file_is_empty: 'El archivo contiene errores. No pudimos procesarlo.',
    contains_no_valid_ids: 'El archivo contiene errores. No pudimos procesarlo.',
    some_ids_are_invalid: 'El archivo contiene errores. No pudimos procesarlo.',
    blockerFormat:
        'Solo podes subir archivos xls o csv. Asegurate que el formato de archivo que estas intentando subir sea el correcto.',
};

const DragDropWithErrors = ({ error, icon, showButton, downloadErrorLink }) => {
    const [text, subtext] = _MESSAGES[error]?.split('.');
    const textModify = text?.replace(/(?<!\.)\bxls\b/g, '.xls')?.replace(/(?<!\.)\bcsv\b/g, '.csv');

    return (
        <div className={style['container']}>
            {icon}
            <div className={style['wrapper-content']}>
                <p className={style['wrapper-text']}>
                    <span className={style['text']}>{textModify}</span>
                    <span className={style['subtext']}>{subtext}</span>
                </p>
                {['file_is_empty'].includes(error) && <span className={style['emptyText']}>Archivo vacío</span>}
                {['contains_no_valid_ids', 'some_ids_are_invalid'].includes(error) && (
                    <div style={{ marginBottom: 8 }}>
                        <ExButton
                            appearance="link"
                            disabled={false}
                            onClick={(e) => {
                                e?.stopPropagation();
                                handlerDownloadErrors(downloadErrorLink);
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                            >
                                <path
                                    d="M8.49996 10.3837C8.41107 10.3837 8.32774 10.3698 8.24996 10.342C8.17218 10.3142 8.09996 10.267 8.03329 10.2003L5.63329 7.80033C5.49996 7.66699 5.43607 7.51144 5.44163 7.33366C5.44718 7.15588 5.51107 7.00033 5.63329 6.86699C5.76663 6.73366 5.92496 6.66421 6.10829 6.65866C6.29163 6.6531 6.44996 6.71699 6.58329 6.85033L7.83329 8.10033V3.33366C7.83329 3.14477 7.89718 2.98644 8.02496 2.85866C8.15274 2.73088 8.31107 2.66699 8.49996 2.66699C8.68885 2.66699 8.84718 2.73088 8.97496 2.85866C9.10274 2.98644 9.16663 3.14477 9.16663 3.33366V8.10033L10.4166 6.85033C10.55 6.71699 10.7083 6.6531 10.8916 6.65866C11.075 6.66421 11.2333 6.73366 11.3666 6.86699C11.4888 7.00033 11.5527 7.15588 11.5583 7.33366C11.5638 7.51144 11.5 7.66699 11.3666 7.80033L8.96663 10.2003C8.89996 10.267 8.82774 10.3142 8.74996 10.342C8.67218 10.3698 8.58885 10.3837 8.49996 10.3837ZM4.49996 13.3337C4.13329 13.3337 3.8194 13.2031 3.55829 12.942C3.29718 12.6809 3.16663 12.367 3.16663 12.0003V10.667C3.16663 10.4781 3.23051 10.3198 3.35829 10.192C3.48607 10.0642 3.6444 10.0003 3.83329 10.0003C4.02218 10.0003 4.18051 10.0642 4.30829 10.192C4.43607 10.3198 4.49996 10.4781 4.49996 10.667V12.0003H12.5V10.667C12.5 10.4781 12.5638 10.3198 12.6916 10.192C12.8194 10.0642 12.9777 10.0003 13.1666 10.0003C13.3555 10.0003 13.5138 10.0642 13.6416 10.192C13.7694 10.3198 13.8333 10.4781 13.8333 10.667V12.0003C13.8333 12.367 13.7027 12.6809 13.4416 12.942C13.1805 13.2031 12.8666 13.3337 12.5 13.3337H4.49996Z"
                                    fill="#0171E6"
                                />
                            </svg>{' '}
                            Descargar errores
                        </ExButton>
                    </div>
                )}
                {showButton && (
                    <ButtonToolbar className={style['buttons-toolbar']}>
                        <ExButton className={`${style['button-action-secondary']}`} appearance="alternative" size="lg">
                            <span>Subir otro archivo</span>
                        </ExButton>
                    </ButtonToolbar>
                )}
            </div>
        </div>
    );
};

export default DragDropWithErrors;
